import { useState } from "react";
import RecepiconIcon from "../../../../assets/images/generico/RecepcionIcon";
import SalirIcon from "../../../../assets/images/generico/SalirIcon";
import SalirIconDrop from "../../../../assets/images/generico/SalirIconDrop";
import {
  ContainerModalAutoT,
  ModalBodyAutoT,
  ModalTopAutoT,
} from "./localStyle";

const ModalAutoT = ({
  title,
  desc,
  textBtnOne,
  textBtnTwo,
  handleChange,
  disableback,
}) => {
  const [active, setActive] = useState(true);

  const handleCerrar = () => {
    // setActive(false);
    // alert("pepe")
  };
  return (
    <ContainerModalAutoT $active={active}>
      {!disableback && (
        <div
          className="backgorund-containerModalAutoT"
          onClick={handleCerrar}
        ></div>
      )}
      <ModalTopAutoT>
        <RecepiconIcon />
        <h1>{title}</h1>
      </ModalTopAutoT>
      <ModalBodyAutoT>
        {typeof desc === "string" ? (
          <div dangerouslySetInnerHTML={{ __html: desc }} className={"desc"} />
        ) : (
          <div className={"desc"}>{desc}</div>
        )}
        <div className="container-btn">
          {textBtnTwo ? (
            <button onClick={handleChange.btnTwo}>
              <SalirIconDrop color={"var(--color-white)"} /> {textBtnTwo}
            </button>
          ) : (
            ""
          )}
          {textBtnOne ? (
            <button onClick={handleChange.btnOne}>
              <SalirIconDrop color={"var(--color-white)"} /> {textBtnOne}
            </button>
          ) : (
            ""
          )}
        </div>
      </ModalBodyAutoT>
    </ContainerModalAutoT>
  );
};

export default ModalAutoT;
